const LEVEL_INDENT_PX = 14;
const CHEVRON_SLOT_PX = 28;

export const getComposerAttributeIndent = (level: number): number => level * LEVEL_INDENT_PX;

/** Leaves have no chevron, but must start to the right of their parent attribute. */
export const getComposerLeafIndent = (attributeLevel: number): number => getComposerAttributeIndent(attributeLevel + 1) + CHEVRON_SLOT_PX;
